import React from "react";

import './style.css';
import { HiOutlineViewList } from 'react-icons/hi';


 let Footer=(props)=> {





  
  return(
    <div id="footer">


Company Name © DeepAI 2021


</div>
  )


}



export default Footer;